module.exports = __webpack_public_path__ + "assets/webgl/skybox.jpg.dxt.784e2ce8.ktx";